import React from 'react';
import LegalPage from '../components/LegalPage';
import PrivacyPolicyContent from '../components/PrivacyPolicyContent';

const PrivacyPolicy: React.FC = () => (
  <LegalPage
    title="Privacy Policy"
    lastUpdated="June 5, 2026"
    backHref="/en/"
  >
    <PrivacyPolicyContent />
  </LegalPage>
);

export default PrivacyPolicy;
